import { Waypoint } from "vue-waypoint";

export default {
  name: "ScenarioDevice",
  props: {
    data: Object,
  },
  components: {
    Waypoint,
  },
  created() {},
};
